export const environment = {
  URL: 'https://stg-spriced-nrp-pas.alpha.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.alpha.simadvisory.com',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
  PROJECT_ID: 'Pricing Action Simulator',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "assets/image.png",
  COMPANY_LOGO_TEXT: "Pricing Action Simulator",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "false",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
  platformApiUrl: 'https://stg-spriced-nrp-pas.alpha.simadvisory.com/spriced/platform',
};
